import React from 'react';
import { Button, notification } from 'antd';
import { downloadExcel } from '../../util/excelUtils';
import { DownloadOutlined } from '@ant-design/icons';

const ExcelTable = ({ tableData, title }) => {
  const role = sessionStorage.getItem("Role");

  const handleDownload = () => {
    if (!tableData || tableData.length === 0) {
      notification.info({
        message: 'No Data Available',
        description: 'There is no data available to download.',
        placement: 'top',
      });
      return;
    }

    let formattedData = [];

    if (title === "Recycle Packaging") {
      formattedData = tableData.map(row => {
        const rowData = {};
        
        if (role === "System Admin") {
          rowData['Company Name'] = row.companyName;
          rowData['Rank']=row.rank;
        }
        
        Object.assign(rowData, {
          'Packaging Use': row.packagingUse,
          'Packaging Format': row.packagingFormat,
          'Packaging Material': row.packagingMaterial,
          'Total Weight (kg)': row.totalWeight,
          'Recyclable Weight (kg)': row.recyclableWeight,
          'Recyclability Percentage (%)': row.recyclabilityPercentage,
          'YoY Change (%)': row.yoyPercentage
        });
        
        return rowData;
      });
    } 
    else if (title === "Carbon Emission Avoided") {
      formattedData = tableData.map(row => {
        const rowData = {};
        Object.assign(rowData, {
          'Company Name':row.companyName,
          'Rank':row.rank,
          'Total Emission ': row.totalEmission,
          'Total Emission Avoided': row.totalEmissionAvoided,
          'Percentage Reduction': row.percentageReduction,
          'YoY Change ': row.yoyPercentage
        });
        
        return rowData;
      });
    } 
    else if (title === "Supplier Submitted Goals") {
      formattedData = tableData.map(row => {
        const rowData = {};
        Object.assign(rowData, {
          'Company Name':row.supplierName,
          'Rank':row.rank,
          'Active Goal Count': row.activeGoalCount,
          'Target Achieved Percentage ': row.targetAchievedPercentage,
          'YoY Change': row.yoy
        });
        
        return rowData;
      });
    }
    else if (title === "CDP Carbon Emission Reported") {
      formattedData = tableData.map(row => {
        const rowData = {};
        Object.assign(rowData, {
          'Company Name':row.companyName,
          'Rank':row.rank,
          'Total Emissions': row.totalCarbonEmission,
          'Emissions Saved ': row.totalEmissionSaved,
          'Percentage Reduction':row.emissionReducedPercentage
        });
        
        return rowData;
      });
    }
    
    else {
      formattedData = tableData;
    }

    console.log(formattedData);
    downloadExcel(formattedData, title);
  };

  return (
    <Button
      onClick={handleDownload}
      className="bg-green-600 w-[150px] hover:bg-green-700 text-white"
    >
      <DownloadOutlined className="text-[20px] font-bold"/>
      Export to Excel
    </Button>
  );
};

export default ExcelTable;